export default {
  async getStatistics(axios, token) {
    return await axios.get('/api/message/reason-for-resolving-statistics/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  },
  async getAgentStatistics(axios, token) {
    return await axios.get('/api/message/reason-for-resolving-agent-statistics/', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
  }
};
